import { InitialsAvatar } from '@/components/common';

interface LeaderAvatarProps {
  readonly name: string;
  /**
   * Posición del líder en la lista final aplanada (pre-order), no el índice de la página visible —
   * el color debe ser estable al paginar.
   */
  readonly colorIndex: number;
}

/** Círculo de iniciales con color secuencial fijo (Fase G, tabla de Líderes en árbol). */
export function LeaderAvatar({ name, colorIndex }: LeaderAvatarProps) {
  return <InitialsAvatar name={name} baseClass="rr-leader-avatar" colorIndex={colorIndex} />;
}
